module.exports = __webpack_public_path__ + "static/media/2_2x.786953e5.png";